exports.baseURL = "https://admin.talentinco.com/";
exports.key = "LiRhuZZejJFrDZEHCtyLO0q2bDuIIhJL";
exports.projectName = "Talent Host"
